module.exports = {
  ...require(`../../firebase-config.development`),
  appId: '1:9929677373:web:84a259efac4aa0d9',
  measurementId: 'G-QR34BHZETR',
};
